// extracted by mini-css-extract-plugin
export default {"details_card_name_container":"components_details_card_name_container__PJqxN"};